// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import api from '../../api';

class DocumentRedirect extends React.Component {
    componentDidMount = () => {
        this.load();
    }

    componentDidUpdate = (prev) => {
        if (this.props.match?.params?.documentId !== prev.match?.params?.documentId || this.props.user?._id !== prev.user?._id)
            this.load();
    }

    load = async () => {
        this.props.loading();

        const documentId = this.props.match?.params?.documentId;
        const query = new URLSearchParams(this.props.location.search);
        const params = query.toString();
        const userId = this.props.user?._id;

        if (!documentId || !userId)
            return;

        const res = await api.get('/document/get?docId=' + documentId + '&minimal=true');
        if (!res || !res.doc)
            return window.location.href = '/';

        window.location.href = api.publicUrl + '/stack/' + (res.doc.stack ? res.doc.stack : 'unclassified') + '/document/' + documentId + (params ? '?' + params : '');
    }

    render = () => <></>
};

export default DocumentRedirect;